export default "__VITE_ASSET__BaSNM2PG__"